"use client";

import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import {Form} from "@/components/ui/form";
import {CWFInput} from "@/components/ui/CWFInput";
import CWFButton from "@/components/ui/CWFButton";
import {useState} from "react";
import axios from "@/lib/axios";


const forgotSchema = yup.object({
    email : yup.string().email("Veuillez fournir une adresse email valie.")
});

export default function ForgotPassRequest({setForgotPass,setActionPass}){

    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);
    const forgotForm = useForm({
        resolver : yupResolver(forgotSchema)
    });
    function forgotSubmit(data){
        axios.post('forgot-pass/request', data)
            .then(res => {
                setActionPass(true);
            })
            .catch(err => {
                setError(true);
            })
    }

    return(
        <Form {...forgotForm}>
            <form onSubmit={forgotForm.handleSubmit(forgotSubmit)} className="grid gap-4">
                {error && (
                    <p className="rounded-md border border-red-300 bg-red-50 text-red-500 text-center text-sm p-1">
                        Adresse email invalide.
                    </p>
                )}
                <CWFInput control={forgotForm.control} name="email" label="Adresse email" type="email" />
                <div className={"flex justify-end"}>
                    <p className={"text-sm text-primary underline cursor-pointer"} onClick={() => setForgotPass(false)}>Retour à la connexion</p>
                </div>
                <CWFButton type="submit" loading={loading}>Retrouver mon mot de passe</CWFButton>
            </form>
        </Form>
    );
}
